import { render, staticRenderFns } from "./btodToNew.vue?vue&type=template&id=c84f815e"
import script from "./btodToNew.vue?vue&type=script&lang=js"
export * from "./btodToNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports